import { render, staticRenderFns } from "./ShippingPrices.vue?vue&type=template&id=31b96398"
import script from "./ShippingPrices.vue?vue&type=script&lang=ts"
export * from "./ShippingPrices.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports